module.exports = __webpack_public_path__ + "static/media/polatlabar.7872cdcf.png";